import PropTypes from "prop-types";
import React, { Component } from "react";
import request from "superagent";
import connectToStores from "alt-utils/lib/connectToStores";
import ResponseStore from "../../../stores/chat/ResponseStore";

import Analytics from "../../../utils/chat/Analytics";
import Author from "../Author";
import { EVENT_ACTIONS } from "../../../constants/AnalyticsConstants";
import MessageType from "../../../constants/ChatMessageTypes";
import Truncate from "../../common/Truncate";
/*eslint-disable*/
import { any } from "lodash/fp";
import { question } from "../ChatPropTypes";
export class AutoResponseMessageButton extends Component {
    constructor() {
        super();

        this.onReadMoreClick = this.onReadMoreClick.bind(this);
        this.onClickXbox = this.onClickXbox.bind(this);
    }

    componentDidMount() {
        const { viewedByUser, messageType, isTerminal } = this.props;
        if (viewedByUser) return;
        if (messageType === MessageType.AutoResponseMessage) {
            Analytics.sendGaEvent({ action: EVENT_ACTIONS.AutoResponseReceived });
        }
        if (isTerminal) {
            Analytics.sendGaEvent({ action: EVENT_ACTIONS.TerminalAutoResponseReceived });
        }
    }

    static getStores() {
        return [ResponseStore];
    }

    static getPropsFromStores() {
        return {
            isTerminal: ResponseStore.hasTerminalAutoResponse(),
        };
    }
    onReadMoreClick() {
        Analytics.sendGaEvent({ action: EVENT_ACTIONS.ReadMore });
        request
            .post("/track/activity")
            .send({
                payload: `Auto-response ${this.props.id} was read entirely.`,
            })
            .end(error => {
                if (error) {
                    console.warn("Error tracking template usage"); // eslint-disable-line no-console
                }
            });
    }
    onClickXbox(url) {
        this.props.getUrl(url);
    }

    render() {
        const {
            author,
            responseMessageAuthor,
            companyName,
            dateCreated,
            id,
            showChatbotNameAndAvatar,
            isTerminal,
            messageTextHtml,
            questionUuid,
            authorUuid,
        } = this.props;
        const authorTitle = i18n.t("rtm.text.company_expert", { companyName });

        const buttonRegex = /button::(https?:\/\/[^\s<]+)/g;
        const hrefRegex = /href::(https?:\/\/[^\s<]+)/g;
        const updatedText = messageTextHtml.split(/(button::[^\s<]+|href::[^\s<]+)/g).map((part, index) => {
            if (buttonRegex.test(part)) {
                const url1 = part.replace("button::", "");
                let url = url1.replace(/&amp;/g, "&");
                const bntUrl = url + "?questionId=" + questionUuid + "&posterId=" + authorUuid;
                return (
                    <button className="xbox-btn" key={index} onClick={() => this.onClickXbox(bntUrl)}>
                        Click here
                    </button>
                );
            } else if (hrefRegex.test(part)) {
                const url1 = part.replace("href::", "");
                const url = url1.replace(/&amp;/g, "&");
                return (
                    <a className="xbox-href" href={url} key={index} target="_blank" rel="noopener noreferrer">
                        Click here
                    </a>
                );
            }

            return <span key={index} dangerouslySetInnerHTML={{ __html: part }} />;
        });
        return (
            <li
                className="message-container is-bot message-auto-response"
                data-date-created={dateCreated}
                data-message-id={id}
            >
                {showChatbotNameAndAvatar && <Author avatarSrc={author.avatarSrc} name={author.name} />}
                <p className="body">
                    {isTerminal
                        ? i18n.t("rtm.text.here_a_recent_answer_similar_question_shortened")
                        : i18n.t("rtm.text.here_a_recent_answer_similar_question")}
                </p>
                <blockquote className="message-auto-response-content">
                    {responseMessageAuthor && (
                        <div className="related-expert">
                            <Author
                                authorTitle={authorTitle}
                                name={responseMessageAuthor.name}
                                avatarSrc={responseMessageAuthor.avatarSrc}
                                avatarSize="30"
                                isCertified={responseMessageAuthor.isCertified}
                                isOfficial={responseMessageAuthor.isOfficial}
                                isElite={responseMessageAuthor.isElite}
                            />
                        </div>
                    )}
                    <Truncate
                        characters={250}
                        ellipsis={
                            <span>
                                ...
                                <div className="truncation-read-more">
                                    <strong>{i18n.t("rtm.text.read_more")}</strong>
                                </div>
                            </span>
                        }
                        onAfterClickMore={this.onReadMoreClick}
                    >
                        <p className="body">{updatedText}</p>
                    </Truncate>
                </blockquote>
            </li>
        );
    }
}

AutoResponseMessageButton.propTypes = {
    author: PropTypes.shape({
        avatarSrc: PropTypes.string,
        name: PropTypes.string,
    }).isRequired,
    /*
     * TODO: Look into why prop validations fails if 'isRequired' is used on 'id'
     */
    id: PropTypes.number,
    messageTextHtml: PropTypes.string.isRequired,
    viewedByUser: PropTypes.bool,
    messageType: PropTypes.string.isRequired,
    responseMessageAuthor: PropTypes.shape({
        avatarSrc: PropTypes.string,
        name: PropTypes.string,
        isCertified: PropTypes.bool,
        isOfficial: PropTypes.bool,
        isElite: PropTypes.bool,
    }),
    companyName: PropTypes.string.isRequired,
    dateCreated: PropTypes.string.isRequired,
    showChatbotNameAndAvatar: PropTypes.bool.isRequired,
    isTerminal: PropTypes.bool.isRequired,
    getUrl: any,
    authorUuid: PropTypes.string,
    questionUuid: PropTypes.string,
};

AutoResponseMessageButton.defaultProps = {
    id: "",
    responseMessageAuthor: undefined,
    viewedByUser: false,
};

export default connectToStores(AutoResponseMessageButton);
